module.exports = __webpack_public_path__ + "static/media/student11.790d75cf.png";